import ContentLoader from 'react-content-loader';
import styles from './Loading.module.less';
import COLORS from '../../theme/colors';

const Loading = () => (
  <div className={styles.loaderFacet}>
    <ContentLoader
      speed={2}
      width="100%"
      height={97}
      foregroundColor={COLORS.fossaGray20}
      backgroundColor={COLORS.fossaGray10}
    >
      <rect x="0" y="0" rx="0" ry="0" width="114" height="24" />
      <rect x="0" y="28" rx="0" ry="0" width="199" height="48" />
      <rect x="0" y="84" rx="0" ry="0" width="289" height="20" />
    </ContentLoader>
  </div>
);

export default Loading;
